import React from 'react';
const links = [{
  label: 'Build your X1',
  href: '#build-your-x1'
}, {
  label: 'Lens system',
  href: '#lenses'
}, {
  label: 'How it works',
  href: '#how'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Support',
  href: '#support'
}];
export function SiteNav() {
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-ink-950/95 backdrop-blur" data-id="element-1171" data-mp="35ofqkn6n3ame">
      <nav aria-label="Main" className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-2 sm:px-6 lg:px-8 lg:py-3" data-id="element-1172" data-mp="31mb2e3yyn675">
        <a href="#top" className="shrink-0" data-id="element-1173" data-mp="2wm6j666o3xd8">
          <span className="block font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-offwhite sm:text-3xl" data-id="element-1174" data-mp="2rnvahys3zswl">
            Grit<span className="text-grit-500" data-id="element-1175" data-mp="2mqv39kjiwk3w">Vue</span>
            <sup className="ml-0.5 align-super text-[9px] text-steel-400" data-id="element-1176" data-mp="pxjties9a1zo">™</sup>
          </span>
          <span className="mt-0.5 hidden text-[9px] font-semibold uppercase tracking-[0.3em] text-steel-400 sm:block" data-id="element-1177" data-mp="ky6yh6r8dom0">
            See the job through
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-1178" data-mp="dyp5ndv1ihqp">
          {links.map(link => <li key={link.href} data-id="element-1179" data-mp="dwcgafmyd53m">
              <a href={link.href} className="text-xs font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1180" data-mp="3v7lvppwwblx4">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href="#build-your-x1" className="inline-flex shrink-0 items-center whitespace-nowrap bg-grit-500 px-3 py-2 font-display text-base font-extrabold uppercase leading-none tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:px-4 sm:text-lg" data-id="element-1181" data-mp="wpgbi5ftjq0c">
          Build your X1<span className="hidden sm:inline" data-id="element-1182" data-mp="1ffeisjbslf2x">&nbsp;— from $29.95</span>
        </a>
      </nav>

      <ul aria-label="Sections" className="flex gap-5 overflow-x-auto border-t border-white/10 px-4 py-1.5 [-ms-overflow-style:none] [scrollbar-width:none] lg:hidden [&::-webkit-scrollbar]:hidden" data-id="element-1183" data-mp="1pboj502vtej1">
        {links.map(link => <li key={link.href} data-id="element-1184" data-mp="1g9f7u7zshh4l">
            <a href={link.href} className="whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1185" data-mp="1gctaziga1ud3">
              {link.label}
            </a>
          </li>)}
      </ul>
    </header>;
}